<template>
  <v-autocomplete
    v-model="select"
    ref="deliverySearch"
    :loading="isLoading"
    :items="carriers"
    :search-input.sync="search"
    :item-text="createSelectLabel"
    color="secondary"
    :label="textLabel || 'Search by Carrier'"
    :return-object="true"
    box
    large
    prepend-inner-icon="search"
    hide-no-data
    clearable
  ></v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "DeliverySearch",
  props: {
    conditions: Array,
    textLabel: String
  },
  data() {
    return {
      select: null,
      search: null,
      waitForTyping: null
    };
  },

  computed: {
    ...mapGetters({
      isLoading: "app/isLoading",
      carriers: "delivery/getCarriers"
    })
  },
  methods: {
    ...mapActions({
      deliverySearch: "delivery/search"
    }),

    createSelectLabel(e) {
      return e.name;
    }
  },

  watch: {
    select(partner) {
      this.$emit("partner-selected", partner);
    },

    async search(value) {
      let conditions = this.conditions;
      conditions = conditions.filter(e => {
        return e.field != "name";
      });

      conditions.push({
        field: "name",
        operator: "ilike",
        value
      });

      conditions.push({
        field: "delivery_type",
        operator: "=",
        value: "fixed"
      })

      clearTimeout(this.waitForTyping);
      if (value) {
        this.waitForTyping = setTimeout(async () => {
          await this.deliverySearch(conditions);
        }, 250);
      }
    }
  }
};
</script>
